import {NgModule} from "@angular/core";
import {MatDividerModule} from "@angular/material/divider";
import {Routes} from "@angular/router";
import {AdminGuardProvider} from "@core/security/admin-guard.provider";
import {TranslateModule} from '@ngx-translate/core';
import {PreviewAlerteModule} from "@share/component/alerte/preview-alerte.module";
import {LoginService} from "@share/login/login.service";
import {ShareModule} from "@share/share.module";
import {ProfilService} from "../../../profil/profil.service";
import {MatLegacyRadioModule as MatRadioModule} from "@angular/material/legacy-radio";
import {DroitAdmin} from "@core/security/droit-admin";
import {NotificationMessagesComponent} from "./messages/notification-messages.component";
import {NotificationRelancesComponent} from "./relances/notification-relances.component";
import {NotificationAccueilComponent} from "./accueil/notification-accueil.component";
import {NotificationMailsComponent} from "./mails/notification-mails.component";
import {BibliothequeNotificationsComponent} from "./bibliotheque-notifications.component";
import {BalisesComponent} from "@components/admin/bibliotheque/notifications/balises/balises.component";
import {BaliseItemComponent} from "@components/admin/bibliotheque/notifications/balises/balise-item/balise-item.component";
import {BaliseDetailComponent} from "@components/admin/bibliotheque/notifications/balises/balise-detail/balise-detail.component";
import {AccueilItemComponent} from "@components/admin/bibliotheque/notifications/accueil/accueil-item/accueil-item.component";
import {AccueilDetailComponent} from "@components/admin/bibliotheque/notifications/accueil/accueil-detail/accueil-detail.component";
import {RoleItemComponent} from "@components/admin/bibliotheque/notifications/accueil/accueil-detail/role-item/role-item.component";
import {AddRolePopinComponent} from "@components/admin/bibliotheque/notifications/accueil/accueil-detail/add-role-popin/add-role-popin.component";
import {RoleSelectItemComponent} from "@components/admin/bibliotheque/notifications/accueil/accueil-detail/add-role-popin/role-select-item/role-select-item.component";
import {DevisesModule} from "@components/admin/bibliotheque/devises/devises.module";
import {CodemirrorModule} from "@ctrl/ngx-codemirror";
import {RelanceListItemComponent} from "./relances/relance-list-item/relance-list-item.component";
import {RelanceDetailComponent} from "./relances/detail/relance-detail.component";
import {SelectRelanceStatutsPopinComponent} from "./relances/detail/select-relance-statuts-popin/select-relance-statuts-popin.component";
import {SelectRelanceRolesPopinComponent} from "./relances/detail/select-relance-roles-popin/select-relance-roles-popin.component";
import {StatutRelanceListItemComponent} from "./relances/detail/select-relance-statuts-popin/statut-list-item/statut-relance-list-item.component";
import {RoleRelanceListItemComponent} from "./relances/detail/select-relance-roles-popin/role-list-item/role-relance-list-item.component";
import {MessageNotifListItemComponent} from "./messages/message-notif-list-item/message-notif-list-item.component";
import {MessageNotifDetailComponent} from "./messages/message-notif-detail/message-notif-detail.component";
import {TinymceInputModule} from '@share/component/tinymce-input/tinymce-input.module';
import {BalisesPopupComponent} from "./messages/balises/balises-popup.component";
import {BalisesListItemComponent} from "./messages/balises/balises-list-item/balises-list-item.component";

export const bibliothequeNotificationsRoutes : Routes = [
    {
        path: 'Notifications',
        component: NotificationMessagesComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_RELANCE_GESTION] }
    }, {
        path: 'Balises/:idBalise',
        component: BaliseDetailComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_RELANCE_GESTION] }
    }, {
        path: 'Balises',
        component: BalisesComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_RELANCE_GESTION] }
    }, {
        path: 'Relances/:idRelance',
        component: RelanceDetailComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_RELANCE_GESTION] }
    }, {
        path: 'Relances',
        component: NotificationRelancesComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_RELANCE_GESTION] }
    }, {
        path: 'Accueil/:idAccueil',
        component: AccueilDetailComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_RELANCE_GESTION] }
    }, {
        path: 'Accueil',
        component: NotificationAccueilComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_RELANCE_GESTION] }
    }, {
        path: 'Mails',
        component: NotificationMailsComponent,
        canActivate: [AdminGuardProvider]
    }, {
        path: 'Message/:idMessage',
        component: MessageNotifDetailComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_RELANCE_GESTION] }
    }, {
        path: '',
        pathMatch: 'full',
        redirectTo: 'Notifications'
    }, {
        path: '**',
        redirectTo: 'Notifications'
    }
];

@NgModule({
    imports: [
        ShareModule,
        PreviewAlerteModule,
        MatDividerModule,
        TranslateModule,
        MatRadioModule,
        DevisesModule,
        CodemirrorModule,
		TinymceInputModule
    ],
    declarations: [
        BibliothequeNotificationsComponent,
        NotificationMessagesComponent,
        NotificationRelancesComponent,
        NotificationAccueilComponent,
        NotificationMailsComponent,
        BalisesComponent,
        BaliseItemComponent,
        BaliseDetailComponent,
        AccueilItemComponent,
        AccueilDetailComponent,
        RoleItemComponent,
        AddRolePopinComponent,
        RoleSelectItemComponent,
		RelanceListItemComponent,
		RelanceDetailComponent,
		SelectRelanceStatutsPopinComponent,
		SelectRelanceRolesPopinComponent,
		StatutRelanceListItemComponent,
		RoleRelanceListItemComponent,
		MessageNotifListItemComponent,
		MessageNotifDetailComponent,
		BalisesPopupComponent,
		BalisesListItemComponent
    ],
    exports: [
        NotificationMessagesComponent,
        NotificationRelancesComponent,
        NotificationAccueilComponent,
        NotificationMailsComponent,
    ],
    providers: [
        ProfilService,
        LoginService,
    ]
})
export class BibliothequeNotificationsModule {
}
